import type { FC } from 'react';
import { useCallback, useState } from 'react';
import { EditOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, Menu, Spin } from 'antd';
import { history } from 'umi';
import HeaderDropdown from '../HeaderDropdown';
import styles from './index.less';
import type { MenuInfo } from 'rc-menu/lib/interface';
import { useModel } from '@@/plugin-model/useModel';
import ChangePassword from '../ChangePassword/Content';

export type GlobalHeaderRightProps = {
  menu?: boolean;
};

const AvatarDropdown: FC<GlobalHeaderRightProps> = () => {
  const { initialState, setInitialState } = useModel('@@initialState');
  const { toLogout } = useModel('user');

  const [visible, setVisible] = useState(false);

  const onMenuClick = useCallback(
    (event: MenuInfo) => {
      const { key } = event;
      if (key === 'logout') {
        toLogout().then((r) => r);
        return;
      }
      if (key === 'modify') {
        setVisible(true);
      }
    },
    [toLogout],
  );

  const loading = (
    <span className={`${styles.action} ${styles.account}`}>
      <Spin size='small' style={{ marginLeft: 8, marginRight: 8 }} />
    </span>
  );

  if (!initialState) {
    return loading;
  }

  const { currentUser } = initialState;

  if (!currentUser || !currentUser.name) {
    return loading;
  }

  const menuHeaderDropdown = (
    // <Menu className={ styles.menu } selectedKeys={ [] } onClick={ onMenuClick }>
    //   <Menu.Item key='info'>
    //     <IdcardOutlined />公司信息
    //   </Menu.Item>
    //   <Menu.Item key='modify'>
    //     <EditOutlined />修改密码
    //     <ChangePassword
    //       visible={ visible } onClose={ (success?: any) => {
    //       setVisible(false)
    //       if (success) {
    //         setInitialState((s) => ({ ...s, currentUser: undefined })).then(r => r)
    //         history.replace({ pathname: LoginPath })
    //       }
    //     } }
    //     />
    //   </Menu.Item>
    //   <Menu.Divider />
    //   <Menu.Item key='logout'>
    //     <LogoutOutlined />退出登录
    //   </Menu.Item>
    // </Menu>
    <>
      <Menu
        className={styles.menu}
        selectedKeys={[]}
        onClick={onMenuClick}
        items={[
          {
            icon: <EditOutlined />,
            key: 'modify',
            label: '修改密码',
            title: '修改密码',
          },
          { type: 'divider' },
          {
            icon: <LogoutOutlined />,
            key: 'logout',
            label: '退出登录',
            title: '退出登录',
          },
        ]}
      />
      <ChangePassword
        visible={visible}
        onClose={(success) => {
          setVisible(false);
          if (success) {
            setInitialState((s) => ({ ...s, currentUser: undefined })).then((r) => r);
            history.replace({ pathname: LoginPath });
          }
        }}
      />
    </>
  );
  return (
    <HeaderDropdown overlay={menuHeaderDropdown} trigger={['click']}>
      <span className={`${styles.action} ${styles.account}`}>
        <Avatar size='small' className={styles.avatar} icon={<UserOutlined />} alt='avatar' />
        <span className={`${styles.name} anticon`}>{currentUser.name}</span>
      </span>
    </HeaderDropdown>
  );
};

export default AvatarDropdown;
